import { captureError } from "@/helpers/captureError";
import { openLootBoxOffChain } from "./openLootBoxOffchain";
export const openLootBoxMeth = async ({ type, amount }) => {
  try {
    return await openLootBoxOffChain({ apeId: 0, type, amount, useMeth: true });
  } catch (err) {
    captureError(err);
  }
};
